<template>
  <div class="dwp-space-y-4 dwp-mb-4" v-if="edit">
    <TextInput v-model="title" ref="input" :data-cy="`input-library-${prop}`" />
    <VButton @click.native="list[prop] = title; edit = false" :data-cy="`save-library-${prop}`">Save</VButton>
    <VButton type="plain" @click.native="title = list[prop]; edit = false">Cancel</VButton>
  </div>
  <div v-else class="dwp-flex dwp-items-center dwp-group">
    <slot>
      <div class="dwp-text-xl dwp-font-medium dwp-truncate" :data-cy="`library-${prop}`">
        <template v-if="list[prop]">{{ list[prop]}}</template>
        <div v-else class="dwp-text-gray-500">No {{ prop }}</div>
      </div>
    </slot>
    <Edit2Icon
      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-text-gray-400 dwp-ml-2 dwp-opacity-0 group-hover:dwp-opacity-100 dwp-transition-opacity dwp-duration-200"
      style="fill:none"
      :data-cy="`edit-library-${prop}`"
      @click.prevent="edit = !edit"
    />
  </div>
</template>

<script>
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import { Edit2Icon } from "vue-feather-icons";

export default {
  components: {
    Edit2Icon,
    TextInput,
    VButton,
  },

  props: {
    list: Object,
    prop: String,
  },

  data() {
    return {
      edit: false,
      title: "",
    };
  },

  watch: {
    edit(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },
  },

  mounted() {
    this.title = this.list[this.prop];
  },
};
</script>